import $ from "jquery";
require('jquery-mousewheel')($);

const BoxSlider = (() => {
  return {
    initialize: function (selectorContainer, selector) {
      const $container = $(selectorContainer);
      const $slider = $container.find(selector);

      const $slickSliderProgress = $('.slick-slider-progress .progress .bar');
      if($slickSliderProgress.length > 0) {
        $slider.on('init reInit beforeChange afterChange', function(event, slick, currentSlide, nextSlide){
          const slide = event.type === 'beforeChange' ? nextSlide : currentSlide;
          const totalSlides = $slider.find('.slick-slide').length;
          let slidesToShow = slick.options.slidesToShow;
          if(typeof slidesToShow === 'undefined' || isNaN(slidesToShow)) {
            slidesToShow = 1;
          }
          const width = 100 / (totalSlides - slidesToShow + 1);
          $slickSliderProgress.css('width', width + '%');
          $slickSliderProgress.css('margin-left', width * slide + '%');
        });
      }

      $slider.slick({
        dots: false,
        arrows: false,
        infinite: false,
        variableWidth: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        slide: '.box:not(.spacer)',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              variableWidth: true,
              slidesToShow: 1,
              slide: '.box'
            }
          },
          {
            breakpoint: 992,
            settings: {
              variableWidth: true,
              slidesToShow: 2,
              slide: '.box'
            }
          },
          {
            breakpoint: 1200,
            settings: {
              variableWidth: true,
              slidesToShow: 3,
              slide: '.box'
            }
          },
        ]
      });

      let additionalScrolls = 0;
      const maxAdditionalScrolls = 1;
      $slider.mousewheel(function(e) {
        const currentSlide = $slider.slick('slickCurrentSlide');
        let slidesToShow = $slider.get(0).slick.options.slidesToShow;
        if(typeof slidesToShow === 'undefined' || isNaN(slidesToShow)) {
          slidesToShow = 1;
        }
        if (e.deltaY < 0) {
          if(currentSlide === $slider.find('.slick-slide').length - slidesToShow) {
            additionalScrolls++;
            if(additionalScrolls <= maxAdditionalScrolls) {
              e.preventDefault();
            }
            return
          }
          additionalScrolls = 0;
          e.preventDefault();
          $slider.slick('slickNext')
        } else {
          if(currentSlide === 0) {
            additionalScrolls++;
            if(additionalScrolls <= maxAdditionalScrolls) {
              e.preventDefault();
            }
            return;
          }
          additionalScrolls = 0;
          e.preventDefault();
          $slider.slick('slickPrev')
        }
      });
      $container.show();
    },
  };
})();

module.exports = BoxSlider;
